<template>
  <div id="member">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$emit('setMenu', 'Member')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/member/Member.vue